// extracted by mini-css-extract-plugin
export var measureBox = "_as-0";